import { cn } from "@/lib/cn";
import { Icon } from "@/shared";
import "./TeamLabel.scss";

export const TeamLabel = ({ className = "" }: { className?: string }) => {
  return (
    <span
      className={cn("team-n9HHgmxnNW", {
        [className]: !!className,
      })}
    >
      <Icon icon="ri-vip-crown-fill" size={11} color="#FFFFFF" />
    </span>
  );
};
